// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3B9jA","type":"styles_type__3Opjt","choices":"styles_choices__2069f"};